import { useTranslation } from "react-i18next";
import { useState } from "react";
import { v4 as uuidv4 } from "uuid";
import DgdocUpload from "../DgBooking/dgdoc-upload";
import { CustomPopup } from "../../../common/Popup/CustomPopup";
import pdf from "../../../assets/images/pdf.png";
import excel from "../../../assets/images/excel.png";
import word from "../../../assets/images/word.png";
import walpaper from "../../../assets/images/walpaper.png";
import document from "../../../assets/images/document.png";
import infoicon from "../../../assets/images/infoicon.png";
import "./russia-section.scss";
import uploadIconBlack from "../../../assets/images/uploadIconBlack.svg"
import { useDropzone } from "react-dropzone";
import DownloadPdf from "./DownloadPdf";
import { deleteRussiaAttachment, saveRussiaAttachments, uploadRussiaAttachment } from "../../../services/quoteServices";
import { connect } from "react-redux";
import { getToastError, getToastSuccess } from "../../../redux/actions/toastActions";
import { Toast } from "primereact/toast";
import { FORM_FIELDS } from "../../../constants";


const RussiaFileUpload = ({
    russiaDocList,
    file,
    setFile,
    searchFormData,
    setIsLoading,
    dispatchToastError,
    dispatchToastSuccess,
    selectedOrigin,
    selectedDestination,
    error
}) => {
    const { t } = useTranslation(["labels", "errors"]);
    const [showRussiaDocList, setShowRussiaDocList] = useState(false);
    const [uuid, setuuid] = useState(uuidv4());
    const [isLoading, setLoading] = useState(false);

    const checkFileName = (acceptedFiles) => {
        let isValid = false;
        if (russiaDocList.length >= 1) {
            const checkArray = russiaDocList.map((el) => {
                return el.fileName;
            });
            const retunCheck = checkArray.includes(acceptedFiles[0].name)
                ? true
                : false;
            return (isValid = retunCheck);
        } else {
            return isValid;
        }
    };

    const onDrop = async (acceptedFiles) => {
        setIsLoading(true);

        var formData = new FormData();
        const filepathArray = acceptedFiles[0]?.path?.split(".");

        if (
            filepathArray[filepathArray.length - 1] !== "xlsx" &&
            filepathArray[filepathArray.length - 1] !== "xls" &&
            filepathArray[filepathArray.length - 1] !== "xlx" &&
            filepathArray[filepathArray.length - 1] !== "docx" &&
            filepathArray[filepathArray.length - 1] !== "pdf" &&
            filepathArray[filepathArray.length - 1] !== "jpeg" &&
            filepathArray[filepathArray.length - 1] !== "png" &&
            filepathArray[filepathArray.length - 1] !== "PNG" &&
            filepathArray[filepathArray.length - 1] !== "JPEG" &&
            filepathArray[filepathArray.length - 1] !== "jpg"
        ) {
            setIsLoading(false);
            dispatchToastError(
                "Upload a vaild file format(pdf ,doc ,xlsx ,xls ,xlx ,jpeg ,png ,JPEG , PNG, jpg)"
            );
            return;
        } else {
            let fileCheck = checkFileName(acceptedFiles);

            if (!fileCheck) {
                formData.append(
                    "attachmentId",
                    searchFormData &&
                        searchFormData?.russiaAttachementDetails &&
                        searchFormData?.russiaAttachementDetails[0]?.attachmentId
                        ? searchFormData?.russiaAttachementDetails[0]?.attachmentId
                        : uuid
                );
                formData.append("multipartFile", acceptedFiles[0]);
                formData.append("country", "RU");
                formData.append("station",  selectedDestination?.code);

                uploadRussiaAttachment(formData).then(async (res) => {
                    setIsLoading(true);
                    try {
                        if (res.status === "SUCCESS") {
                            setIsLoading(false);
                            //call toaster
                            await dispatchToastSuccess("File uploaded successfully");
                            // setFile(null);
                            setFile([res]);
                        }
                    } catch (error) {

                        setIsLoading(false);
                        setFile(null);
                        dispatchToastError("Failed to upload file");
                        return;
                    }
                }).catch((error) => {

                    setIsLoading(false);
                    setFile(null);
                    dispatchToastError("Failed to upload file");
                    return;
                });
            } else {
                // formData.append("attachmentId", uuidv4());
                setIsLoading(false);
                dispatchToastError("File already Exists");
            }
        }
    };

    const { getRootProps, getInputProps } = useDropzone({
        onDrop,
        multiple: false,
    });

    const handleRemoveRussiaDoc = (element, index) => {
        const data = {
            attachmentId: element.attachmentId,
            fileName: element.fileName,
            id: element.id,
        };
        setIsLoading(true);
        deleteRussiaAttachment(data).then(async (res) => {
            try {
                if (res.status === "SUCCESS") {
                    setIsLoading(false);
                    //call toaster
                    dispatchToastSuccess("File Deleted");
                    // myToast.current.show({ ...toastDetails, life: 4000 })
                    const itemsTemp = russiaDocList.filter((element, curr) => {
                        return index !== curr;
                    });
                    const filesTemp = file.filter((item, curr) => {
                        return item?.attachmentId !== element.attachmentId;
                    })
                    setRussiaDocList([...itemsTemp]);
                    setFile([...filesTemp]);
                }
            } catch (error) {
                setIsLoading(false);
                setFile(null);
                dispatchToastError("Failed to Delete");
            }
        }).catch((error) => {
            setIsLoading(false);
            setFile(null);
            dispatchToastError("Failed to Delete");
        });
    };

    return (<div className="ru-doc-upload-section">
        <label className="upload-main-head">
            {t("BOOKING.RU_REQUIRED_DOCUMENTS")}
        </label>
        <div className="russia-upload-body">
            <div className="upload-doc-label-info">
                <label className="upload-doc-label">
                    {russiaDocList.length > 0
                        ? `${t("COMMON.FILE_DG_UPLOADED")}`
                        : `${t("BOOKING.UPLOAD_REQUIRED_DOCUMENTS")}`}
                </label>
                <img
                    src={infoicon}
                    onClick={() => setShowRussiaDocList(true)}
                    alt="Allowed list"
                    title="Allowed list"
                    className="upload-doc-icon"
                />
            </div>

            <div className="ru-upload-download-section">
                <div className="ru-file-upload-section">
                    <div className="ru-file-upload-block">
                        <div className="ru-upload-content-block" {...getRootProps()}>
                            <input {...getInputProps()} id="ru-doc-upload" />
                            <img
                                src={uploadIconBlack}
                                alt="upload"
                                title="upload"
                                id="ru-upload-icon"
                            />
                            <div className="ru-upload-drop-label">
                                <label className="ru-upload-label" >
                                    {t("COMMON.UPLOAD_CLICK")}
                                </label>
                                <label className="ru-drop-label">{t("COMMON.UPLOAD_DROP")}</label>
                            </div>
                            <label className="ru-drop-label">{t("COMMON.UPLOAD_TYPE_INFO")}</label>
                        </div>
                    </div>
                </div>
                <DownloadPdf />
            </div>


            <CustomPopup
                isVisible={showRussiaDocList}
                footerPriBtnLabel={t("COMMON.OK")}
                footerPriBtnClick={() => setShowRussiaDocList(false)}
                headerComponent={{
                    mainHeader: t("COMMON.DOC_REQUIRED"),
                }}
                onClose={() => setShowRussiaDocList(false)}
                body={
                    <ul
                        className="ml-4"
                        style={{ listStyle: "disc" }}
                    >
                        <li>{t("BOOKING.RU_DECLARATION")}</li>
                        <li>{t("BOOKING.RU_COMMERCIAL_INVOICE")}</li>
                        <li>{t("BOOKING.RU_PACKING_LIST")}</li>
                        <li>{t("BOOKING.RU_INDEMNITY_LETTER")}</li>
                        <li>{t("BOOKING.RU_END_USER_CERTIFICATE")}</li>
                        <li>{t("BOOKING.RU_AUTH_LICENSE")}</li>
                    </ul>
                }
            />
            {(file?.length > 0 ||
                russiaDocList?.length > 0) && (
                    <ul className="ru-up-file-list">
                        {russiaDocList?.map((element, i) => {
                            const filArraypath =
                                element?.fileName?.split(".");
                            return (
                                <li className="ru-up-file">
                                    <div
                                        className="up-file-details"
                                        key={i}
                                    >
                                        <img
                                            src={
                                                filArraypath &&
                                                    filArraypath[1] === "pdf"
                                                    ? pdf
                                                    : (filArraypath &&
                                                        filArraypath[1] ===
                                                        "xlsx") ||
                                                        (filArraypath &&
                                                            filArraypath[1] === "xls")
                                                        ? excel
                                                        : filArraypath &&
                                                            filArraypath[1] === "docx"
                                                            ? word
                                                            : (filArraypath &&
                                                                filArraypath[1] ===
                                                                "png") ||
                                                                (filArraypath &&
                                                                    filArraypath[1] ===
                                                                    "jpeg") ||
                                                                (filArraypath &&
                                                                    filArraypath[1] === "jpg")
                                                                ? walpaper
                                                                : document
                                            }
                                            alt={
                                                filArraypath && filArraypath[1]
                                            }
                                            title={
                                                filArraypath && filArraypath[1]
                                            }
                                        />
                                        <span> {element.fileName}</span>
                                    </div>
                                    <span
                                        className="up-file-delete"
                                        onClick={(e) =>
                                            handleRemoveRussiaDoc(element, i)
                                        }
                                    >
                                        {t("COMMON.DELETE")}
                                    </span>
                                </li>
                            );
                        })}
                    </ul>
                )}


        </div>
        <span className="search-panel__errormsg">
            {error?.[FORM_FIELDS.RUSSIA_DOCS]
                ? t(error[FORM_FIELDS.RUSSIA_DOCS], {
                    ns: "errors",
                })
                : ""}
        </span>
    </div>
    )
}

const mapStateToProps = ({ loader, toast }) => ({
    //	principal: auth.principal,
    //	isLoading: loader.isLoading,
    toastDetails: toast.toastDetails,
});

const mapDispatchToProps = (dispatch) => ({
    dispatchToastSuccess: (message) => {
        dispatch(getToastSuccess(message));
    },
    dispatchToastError: (message) => {
        dispatch(getToastError(message));
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(RussiaFileUpload);